export const navigate = (path: string, newTab = false) => {
  if (newTab) {
    window.open(path, '_blank');
  } else {
    window.location.href = path;
  }
};

export interface Deferred<T> {
  promise: Promise<T>;
  resolve: (next: T) => void;
  reject: (cause: any) => void;
}

export const getDeferred = <T>(): Deferred<T> => {
  const deferred: Partial<Deferred<T>> = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred as Deferred<T>;
};

export function waitForBoolean(
  condition: () => boolean,
  intervalMs = 50,
  timeoutMs = 10000
): Promise<boolean | null> {
  const conditionName = condition.name || 'anonymous function';
  const deferred = getDeferred<boolean>();
  let interval: ReturnType<typeof setInterval> = NaN;
  let timeout: ReturnType<typeof setTimeout> = NaN;

  interval = setInterval(() => {
    if (condition()) {
      clearInterval(interval);
      clearTimeout(timeout);
      return deferred.resolve(true);
    }
  }, intervalMs);

  timeout = setTimeout(() => {
    clearInterval(interval);
    return deferred.reject(
      new Error(
        `Failed to verify '${conditionName}' within ${timeoutMs} milliseconds.`
      )
    );
  }, timeoutMs);

  return deferred.promise;
}
